<div class="file-upload" [ngClass]="theme" [class.drag-over]="isDragEnter" (dragenter)="onDragEnter($event)"
  (dragover)="onDragOver($event)" (dragleave)="onDragLeave($event)" (drop)="onDrop($event)">

  <!-- BEFORE CHOICE -->
  <ng-container *ngIf="flowState === FLOW_STATE.UNSELECTED; else fileSelected">
    <button mat-flat-button extended color="primary" class="file-select-btn" (click)="file.click()">
      <mat-icon id="img-upload">cloud_upload</mat-icon>
      {{text | translate}}
    </button>
    <input hidden type="file" #file [accept]="accept" (change)="onChangeFileInput($event)">
    <button *ngIf="showScan" mat-flat-button extended color="primary" class="file-select-btn" (click)="startScan()">
      <mat-icon id="img-upload">document_scanner</mat-icon>
      {{'scanDoc' | translate}}
    </button>
    <span class="file-upload-text"><ng-container *ngIf="maxSize"> ({{'maxSize' | translate: {number: maxSize}
        }})</ng-container>
      <ng-container *ngIf="hasStrictSize"> ({{'badStrictSize' | translate: {width: width, height: height}
        }})</ng-container></span>
    <!-- feedback -->
    <span *ngIf="msgType === MSG_TYPE_ENUM.SUCCESS"
      class="alert alert-success file-upload-feedback">{{'uploadFile.success' | translate}}</span>
  </ng-container>

  <!-- AFTER CHOICE -->
  <ng-template #fileSelected>
    <!-- loading -->
    <div class="wrap-spinner" *ngIf="loadingModel; else content">
      <mat-spinner [diameter]="20"></mat-spinner>
    </div>
    <!-- content -->
    <ng-template #content>
      <ng-container *ngIf="isStandAlone">
        <!-- info file -->
        <div class="file-upload-info-file">
          <span class="file-upload-info-file-text">{{file.name}}</span>
          <button mat-icon-button color="primary" (click)="onRemoveFile(false)">
            <mat-icon id="file-upload-info-file-icon">delete_forever</mat-icon>
          </button>
        </div>
        <!-- button -->
        <button mat-flat-button color="primary" class="file-upload-btn" (click)="onClickBtn()"
          [disabled]="depasse || badStrictSize">{{uploadText |
          translate}}</button>
      </ng-container>

      <!-- feedback -->
      <span *ngIf="msgType === MSG_TYPE_ENUM.ERROR" class="alert alert-danger file-upload-feedback">{{'uploadFile.error'
        |
        translate}}</span>
      <span *ngIf="depasse" class="alert alert-danger file-upload-feedback">{{'maxSize' | translate: {number: maxSize}
        }}</span>
      <span *ngIf="badStrictSize" class="alert alert-danger file-upload-feedback">{{'badStrictSize' | translate: {width:
        width, height: height} }}</span>

    </ng-template>
  </ng-template>
</div>